import { order_by, Selector } from '../../lib/generated/zeus';
import { activeRecord } from '../../lib/graphql/common/queries';

export const teamNameSelector = Selector('team')({
  name: true,
});

export const teamRoleSelector = Selector('team_role')({
  id: true,
  name: true,
  role_group: true,
  read_only: true,
  record_status: true,
});

export const teamUserSelector = Selector('user')({
  id: true,
  first_name: true,
  last_name: true,
  email_address: true,
  external_id: true,
  user_name: true,
  user_type: true,
});

export const userRoleAssignmentSelector = Selector('user_role_assignment')({
  id: true,
  record_status: true,
  user: teamUserSelector,
});

export const teamRoleAssignmentSelector = Selector('team_role_assignment')({
  id: true,
  team_role_id: true,
  team_role: teamRoleSelector,
  user_role_assignments: [
    {
      where: { ...activeRecord, user: activeRecord },
    },
    userRoleAssignmentSelector,
  ],
});

export const teamSelector = Selector('team')({
  id: true,
  name: true,
  team_type: true,
  internal_order_number: true,
  cost_object: {
    description: true,
  },
  record_status: true,
  team_settings: [{}, true],
  team_role_assignments: [
    {
      where: {
        ...activeRecord,
      },
      order_by: [
        {
          team_role: {
            name: order_by.asc,
          },
        },
      ],
    },
    teamRoleAssignmentSelector,
  ],
});

export const costObjectSelector = Selector('cost_object')({
  internal_order_number: true,
  description: true,
  record_status: true,
  order_type: true,
  owner_number: true,
});
